import React, { useState, useRef, useEffect } from "react";
import { Settings } from "lucide-react";

const OPTIONS = [
  { key: "conversionFromFirst", label: "Conversion from first step" },
  { key: "conversionFromPrevious", label: "Conversion from previous step" },
  { key: "stepCount", label: "Step count" },
  { key: "avgTimeFromFirst", label: "Average time from first step" },
  { key: "avgTimeFromPrevious", label: "Average time from previous step" },
];

/**
 * Gear popover: which columns to show for funnel steps 2+ in the data table (funnel-steps chart).
 */
export default function FunnelTableColumnSettings({
  columns,
  onColumnsChange,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const toggle = (key) => {
    if (key === "conversionFromPrevious" || key === "stepCount") {
      const next = { ...columns, [key]: !columns[key] };
      if (!next.conversionFromPrevious && !next.stepCount) return;
      onColumnsChange(next);
      return;
    }
    onColumnsChange({ ...columns, [key]: !columns[key] });
  };

  return (
    <div className="relative" ref={wrapRef}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border transition-colors"
        style={{
          borderColor: "var(--border-default)",
          backgroundColor: open ? "var(--surface-sunken)" : "var(--surface-base)",
          color: "var(--text-muted)",
        }}
        title="Funnel table columns"
        aria-expanded={open}
        aria-haspopup="dialog"
        aria-label="Customize funnel table columns"
      >
        <Settings className="h-4 w-4" strokeWidth={2} />
      </button>
      {open && (
        <div
          className="absolute left-0 top-full z-[120] mt-1 w-[min(100vw-2rem,18rem)] rounded-lg border p-2.5 shadow-lg"
          style={{
            backgroundColor: "var(--surface-base)",
            borderColor: "var(--border-default)",
          }}
          role="dialog"
          aria-label="Funnel table column options"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <ul className="space-y-1.5">
            {OPTIONS.map(({ key, label }) => (
              <li key={key}>
                <label className="flex cursor-pointer items-start gap-2 text-[11px] leading-snug text-ink">
                  <input
                    type="checkbox"
                    className="mt-0.5 h-3.5 w-3.5 shrink-0 rounded border-line-strong"
                    style={{
                      accentColor: "var(--brand-primary)",
                    }}
                    checked={!!columns[key]}
                    onChange={() => toggle(key)}
                  />
                  <span>{label}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
